import { parseAsString } from "nuqs/server";

export const memoDateFilterSearchParamParsers = {
  memoDate: parseAsString,
  memoDateStart: parseAsString,
  memoDateEnd: parseAsString,
} as const;

/**
 * nuqs の query state 更新で memo list 専用の日付 filter を消すための partial state です。
 */
export function clearedMemoDateFilterQueryState() {
  return {
    memoDate: null,
    memoDateStart: null,
    memoDateEnd: null,
  } as const;
}
